import { Injectable } from '@angular/core';
import { Models } from '@ibexfusion/models';

import { RestProvider, RestService } from '../rest/rest.service';
import { RestfulService } from '../rest/restful';

@Injectable()
export class ExternalTokensService extends RestfulService<Models.ExternalToken> {

  constructor(public restService: RestService) {
    super(Models.ExternalToken);
    super.init();
  }

  public createProvider(): RestProvider {
    return this.restService.createProvider('external-tokens');
  }
}
